import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { userStore } from '../stores/user.store';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs/operators';

export const authGuardDeny: CanActivateFn = () => {
    const store = inject(userStore);
    const router = inject(Router);
    if (!store.isAuthenticated()) {
        // Try to refresh the token if we have one
        if (localStorage.getItem('refresh_token')) {
            store.checkAuthState();

            // Convert isLoading signal to observable and wait for it to become false
            return toObservable(store.isLoading)
                .pipe(
                    filter(isLoading => !isLoading),
                    take(1),
                    map(() => (store.isAuthenticated() && store.is_user_verified())|| router.parseUrl('/login'))
                );
        }
        return router.parseUrl('/login');
    }else if(!store.is_user_verified()){
        return false
    }
    return true;
};

export const authGuardAllow: CanActivateFn = () => {
    const store = inject(userStore);
    const router = inject(Router);
   
    if (store.isAuthenticated()) {
        return router.parseUrl('/console');
    }
    // After a reload the user isn't restored yet: restore it from the refresh token first, so a
    // signed-in user opening /login goes straight to the console.
    if (localStorage.getItem('refresh_token')) {
        store.checkAuthState();
        return toObservable(store.isLoading)
            .pipe(
                filter(isLoading => !isLoading),
                take(1),
                map(() => (store.isAuthenticated() && store.is_user_verified()) ? router.parseUrl('/console') : true)
            );
    }
    return true;
};
